  export const getFormattedProductList = (data: any, labelName: string) => {
    let formattedProduct = data.map(
      (product: { _id: string; name: string; type: string }) => {
        let productObj: { value: string | number; label: string } = {
          value: "",
          label: "",
        };
        productObj.value = product._id;
        productObj.label = product.name;
        return productObj;
      }
    );
    formattedProduct.unshift({
      value: "",
      label: labelName,
    });
    return formattedProduct;
  };
  
  export const getFormattedLwwTicketData = (data: any) => {
    return data.map((item: any) => {
        return {
            _id: item._id || "",
            user: item.user
                ? {
                    name: item.user.name || "",
                    email: item.user.email || "",
                    phone: item.user.phone || "",
                    countryCode: item.user.countryCode || ""
                }
                : {},
            items: item.items
                ? item.items.map((product: any) => ({
                    discountAmount: product.discountAmount || 0,
                    discountPercentage: product.discountPercentage || 0,
                    isDependent: product.isDependent || false,
                    isFree: product.isFree || false,
                    isFreeCount: product.isFreeCount || 0,
                    _id: product._id || "",
                    productId: product.productId || "",
                    qty: product.qty || 0,
                    date: product.date || "",
                    totalPrice: product.totalPrice || 0,
                    unitPrice: product.unitPrice || 0,
                    name: product.name || "",
                    category: product.category || "",
                    productCode: product.productCode || "",
                    dependentProduct: product.dependentProduct || null,
                    slots: product.slots || null
                }))
                : [],
            bookingDate: item.bookingDate || "",
            finalAmount: item.finalAmount || 0,
            paymentMethod: item.paymentMethod || "",
            transactionId: item.transactionId,
            ticketNo: item.ticketNo || "",
            updatedAt: item.updatedAt || "",
            transaction: item.transaction
            ? {
              transactionId: item.transaction.transactionId || "",
              orderId: item.transaction.orderId || ""
           }
           : {}
        };
    });
  };


  